/**
 * Match Confidence Levels
 *
 * Defines the possible confidence levels for the match confidence meter.
 * These levels indicate how confident we are in the supplier matches
 * based on the information provided by the user.
 */
const MatchConfidenceLevel = {
  NULL: '-',
  FAIR: 'fair',
  MEDIUM: 'medium',
  HIGH: 'high',
};

export default MatchConfidenceLevel;
